'use strict';

var StrategyConditionDataService = function StrategyConditionDataService(strategyRecordDataService) {
  var mapping = require('./../config/condition-data-mapping');
  function getOperandData(fieldId) {
    return strategyRecordDataService.getOperandData(mapping, fieldId);
  }
  return {
    getOperandData: getOperandData
  };
};
StrategyConditionDataService.$inject = ['StrategyRecordDataService'];
module.exports = StrategyConditionDataService;